import { passwordProblem, PASSWORD_MIN_LENGTH } from '../../lib/password';
import { Input } from '../ui/input';

export interface NewPasswordState {
  password: string;
  repeat: string;
}

/** What stops the form from being submitted, or null. Shared by setup, forced change and the account page. */
export function newPasswordProblem(state: NewPasswordState, email?: string | null): string | null {
  const problem = passwordProblem(state.password, email);
  if (problem) return problem;
  if (state.password !== state.repeat) return 'Пароли не совпадают';
  return null;
}

/** "New password" + "repeat" with the reason it is not accepted yet shown underneath. */
export function NewPasswordFields({
  value,
  onChange,
  email,
  idPrefix,
  extraProblem,
}: {
  value: NewPasswordState;
  onChange: (next: NewPasswordState) => void;
  email?: string | null;
  idPrefix: string;
  /** A reason only the parent form can know (e.g. "same as the current password"). */
  extraProblem?: string | null;
}) {
  const touched = value.password.length > 0 || value.repeat.length > 0;
  const problem = touched ? (newPasswordProblem(value, email) ?? extraProblem ?? null) : null;
  return (
    <>
      <label className="mb-3 block text-sm" htmlFor={`${idPrefix}-new`}>
        Новый пароль
        <Input
          id={`${idPrefix}-new`}
          className="mt-1"
          type="password"
          autoComplete="new-password"
          value={value.password}
          onChange={(e) => onChange({ ...value, password: e.target.value })}
          required
        />
      </label>
      <label className="mb-2 block text-sm" htmlFor={`${idPrefix}-repeat`}>
        Повторите пароль
        <Input
          id={`${idPrefix}-repeat`}
          className="mt-1"
          type="password"
          autoComplete="new-password"
          value={value.repeat}
          onChange={(e) => onChange({ ...value, repeat: e.target.value })}
          required
        />
      </label>
      <p className={problem ? 'mb-3 text-xs text-red-600' : 'mb-3 text-xs text-muted-fg'} data-testid={`${idPrefix}-hint`}>
        {problem ?? `Не короче ${PASSWORD_MIN_LENGTH} символов, не совпадает с email и не из числа очевидных.`}
      </p>
    </>
  );
}
